"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = GusEntitiesPage;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const EntitiesBadges_1 = require("../../Entities/EntitiesBadges");
const EntityModalButtons_1 = require("../../Entities/Modals/EntityModalButtons");
const gusEntityService_1 = require("../../Entities/gusEntityService");
const LIST_TILES = [
    { key: "diff", title: "Różni się co do rzeczy", note: "Do przejrzenia. Każda pozycja otwiera okno podmiotu." },
    {
        key: "duplicateNips",
        title: "Ten sam NIP w dwóch rekordach",
        note: "Zmiana nazwy spółki albo cudzy numer. Rozstrzygasz parami.",
    },
    { key: "withoutNip", title: "Bez NIP-u", note: "Poza zasięgiem rejestru, dopóki nie uzupełnisz numeru." },
    { key: "closed", title: "Wykreślone z rejestru", note: "Do wiadomości. Zostają w słowniku razem z historią." },
    { key: "diffMinor", title: "Inny zapis tej samej rzeczy", note: "Cicha lista. Nic nie wymaga reakcji." },
];
function countOf(report, key) {
    if (!report)
        return 0;
    if (key === "duplicateNips")
        return report.duplicateNips.length;
    return report[key].length;
}
function EntityRow({ entity, onEdited }) {
    // Lista z zestawienia niesie tylko numer, nazwę, NIP i wynik porównania. Okno podmiotu
    // potrzebuje całego rekordu (migawka z rejestru!), więc dociąga go sobie samo.
    const initialData = { id: entity.id, name: entity.name ?? "", taxNumber: entity.taxNumber ?? "" };
    return (react_1.default.createElement("div", { className: "d-flex flex-wrap align-items-center gap-2 border-bottom py-2" },
        react_1.default.createElement("div", { className: "flex-grow-1" },
            react_1.default.createElement("div", null, entity.name || `Podmiot nr ${entity.id}`),
            react_1.default.createElement("div", { className: "text-muted small" },
                "NIP: ",
                entity.taxNumber || "brak")),
        react_1.default.createElement(EntitiesBadges_1.GusStatusBadge, { status: entity.gusStatus, checkedAt: entity.gusCheckedAt }),
        react_1.default.createElement(EntityModalButtons_1.EntityEditModalButton, { modalProps: {
                onEdit: onEdited,
                initialData,
                shouldRetrieveDataBeforeEdit: true,
            }, buttonProps: { buttonCaption: "Otwórz", buttonVariant: "outline-primary" } })));
}
function GusEntitiesPage({ title }) {
    const [report, setReport] = (0, react_1.useState)(null);
    const [reportLoading, setReportLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const [selectedList, setSelectedList] = (0, react_1.useState)("diff");
    const [sweeping, setSweeping] = (0, react_1.useState)(false);
    const [progress, setProgress] = (0, react_1.useState)(null);
    const [sweepMessage, setSweepMessage] = (0, react_1.useState)(null);
    /** Przerwany przebieg nie jest sukcesem i nie ma prawa świecić na zielono. */
    const [sweepAborted, setSweepAborted] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        document.title = title;
    }, [title]);
    const loadReport = (0, react_1.useCallback)(async () => {
        setReportLoading(true);
        setError(null);
        try {
            setReport(await (0, gusEntityService_1.fetchGusReport)());
        }
        catch (err) {
            setError(err instanceof Error ? err.message : "Nie udało się pobrać zestawienia");
        }
        finally {
            setReportLoading(false);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        loadReport();
    }, [loadReport]);
    async function handleSweep() {
        setSweeping(true);
        setSweepMessage(null);
        setError(null);
        setProgress(null);
        try {
            const result = await (0, gusEntityService_1.runGusSweepLoop)((current) => setProgress(current));
            setSweepAborted(result.aborted);
            setSweepMessage(result.aborted
                ? `Przebieg przerwany: ${result.abortReason ?? "nieznany powód"}. Sprawdzono ${result.checked} podmiotów.`
                : `Przebieg zakończony: sprawdzono ${result.checked} podmiotów w ${result.passes} partiach.`);
            await loadReport();
        }
        catch (err) {
            setError(err instanceof Error ? err.message : "Błąd przebiegu");
        }
        finally {
            setSweeping(false);
        }
    }
    const percent = (0, react_1.useMemo)(() => {
        if (!progress || progress.total === 0)
            return 0;
        return Math.min(100, Math.round((progress.checked / progress.total) * 100));
    }, [progress]);
    const selectedTile = LIST_TILES.find((tile) => tile.key === selectedList);
    return (react_1.default.createElement(react_bootstrap_1.Container, { fluid: true, className: "px-3" },
        react_1.default.createElement("h4", { className: "mb-1" }, "Podmioty w GUS"),
        react_1.default.createElement("p", { className: "text-muted" }, "Przebieg rusza sam pierwszego dnia miesi\u0105ca. Ten przycisk jest na wtedy, gdy nie chcesz czeka\u0107. Sprawdzenie zapisuje wy\u0142\u0105cznie wynik por\u00F3wnania \u2014 nazwa i adres podmiotu zmieniaj\u0105 si\u0119 dopiero po przyj\u0119ciu ich w oknie podmiotu."),
        react_1.default.createElement("div", { className: "d-flex flex-wrap align-items-center gap-3 mb-2" },
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", onClick: handleSweep, disabled: sweeping }, sweeping ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm", className: "me-1" }),
                "Sprawdzanie...")) : ("Sprawdź wszystkie w GUS")),
            progress && (react_1.default.createElement("span", { className: "text-muted small" },
                "partia ",
                progress.passes,
                " \u00B7 sprawdzono ",
                progress.checked,
                " \u00B7 zosta\u0142o",
                " ",
                progress.remaining,
                " podmiot\u00F3w"))),
        progress && react_1.default.createElement(react_bootstrap_1.ProgressBar, { now: percent, label: `${percent}%`, className: "mb-3" }),
        sweepMessage && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: sweepAborted ? "warning" : "success", onClose: () => setSweepMessage(null), dismissible: true }, sweepMessage)),
        error && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", onClose: () => setError(null), dismissible: true }, error)),
        react_1.default.createElement(react_bootstrap_1.Row, { className: "g-3 mb-3" }, LIST_TILES.map((tile) => (react_1.default.createElement(react_bootstrap_1.Col, { key: tile.key, xs: 12, md: 6, lg: 4, xl: 3 },
            react_1.default.createElement(react_bootstrap_1.Card, { role: "button", onClick: () => setSelectedList(tile.key), border: selectedList === tile.key ? "primary" : undefined, className: "h-100" },
                react_1.default.createElement(react_bootstrap_1.Card.Body, null,
                    react_1.default.createElement("div", { className: "fs-3 fw-bold" }, countOf(report, tile.key)),
                    react_1.default.createElement(react_bootstrap_1.Card.Title, { as: "h6" }, tile.title),
                    react_1.default.createElement(react_bootstrap_1.Card.Text, { className: "text-muted small" }, tile.note))))))),
        react_1.default.createElement(react_bootstrap_1.Card, null,
            react_1.default.createElement(react_bootstrap_1.Card.Header, null,
                react_1.default.createElement("strong", null, selectedTile.title),
                " ",
                react_1.default.createElement("span", { className: "text-muted small" }, selectedTile.note)),
            react_1.default.createElement(react_bootstrap_1.Card.Body, null,
                reportLoading && react_1.default.createElement(SpinnerLine, null),
                !reportLoading && !report && react_1.default.createElement("div", { className: "text-muted" }, "Brak zestawienia."),
                !reportLoading && report && selectedList === "duplicateNips" && (react_1.default.createElement(DuplicatesList, { report: report, onEdited: loadReport })),
                !reportLoading && report && selectedList !== "duplicateNips" && (react_1.default.createElement(PlainList, { entities: report[selectedList], onEdited: loadReport }))))));
}
function SpinnerLine() {
    return (react_1.default.createElement("div", { className: "text-muted" },
        react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm", className: "me-2" }),
        "Wczytywanie zestawienia..."));
}
function PlainList({ entities, onEdited }) {
    if (entities.length === 0)
        return react_1.default.createElement("div", { className: "text-muted" }, "Pusto \u2014 nic tu nie czeka.");
    return (react_1.default.createElement(react_1.default.Fragment, null, entities.map((entity) => (react_1.default.createElement(EntityRow, { key: entity.id, entity: entity, onEdited: onEdited })))));
}
function DuplicatesList({ report, onEdited }) {
    if (report.duplicateNips.length === 0)
        return react_1.default.createElement("div", { className: "text-muted" }, "Pusto \u2014 nic tu nie czeka.");
    return (react_1.default.createElement(react_1.default.Fragment, null, report.duplicateNips.map((group) => (react_1.default.createElement("div", { key: group.nip, className: "mb-3" },
        react_1.default.createElement("div", { className: "fw-bold" },
            "NIP ",
            group.nip),
        group.entities.map((entity) => (react_1.default.createElement(EntityRow, { key: entity.id, entity: entity, onEdited: onEdited }))))))));
}
